import type { InboundComment } from '@/infrastructure/FulfillmentAdminClient';
import { kstTimestamp } from '@/utils/fulfillmentTime';

export interface InboundCommentThreadProps {
  /** The request's thread as the detail read returns it; an older server may leave it out. */
  comments: InboundComment[] | undefined;
  /** Names the list for screen readers, e.g. the request's inbound number. */
  label: string;
}

/**
 * One inbound request's notes, written by people and by the desk alike, in the order they were added.
 * Shared by the request list's pane, the request's detail page and the scan desk's inbound view, so a note
 * reads the same wherever someone meets it. The `c-item`/`who` classes let the scan desk's own panel style it.
 */
export function InboundCommentThread({ comments, label }: InboundCommentThreadProps) {
  const thread = comments ?? [];
  if (thread.length === 0) {
    return <div className="empty text-muted small mb-2">No notes yet</div>;
  }
  return (
    <ul className="list-unstyled mb-0" aria-label={label}>
      {thread.map((comment, index) => (
        <li key={comment.idempotencyKey || `${comment.at}-${index}`} className="c-item small mb-1">
          <span className="who fw-semibold me-2">{comment.author}</span>
          <span style={{ whiteSpace: 'pre-wrap' }}>{comment.text}</span>
          <time className="text-muted ms-2" dateTime={comment.at}>
            {kstTimestamp(comment.at)}
          </time>
        </li>
      ))}
    </ul>
  );
}
